export const themeColor = [
  "#FFFFFF",
  "#DECCCC",
  "#86BBD8",
  "#33658a",
  "#758E4F",
  "#F6AE2D",
  "#F26419",
  "#A63D40",
  "#66462C",
  "#151515",
];
